<template>

    <div class="temoignages">

        <a class="temoignages-item" v-for="(item, index) in items">
            <a href="#" class="temoignages-item-bar" :id="'temoignages-item-bar__' + index"
               @click.prevent="setActive(index)"
               :class="{ 'active' : active === index }">
                <p class="temoignages-item-type" v-html="item.type"></p>
                <img v-if="item.pictureRounded" class="temoignages-item-picture"
                     :src="require('../assets/' + item.pictureRounded)">
                <div>
                    <p class="temoignages-item-name">{{ item.name }}</p>
                    <p class="temoignages-item-body">{{ item.body }}</p>
                </div>
                <div class="temoignages-item-more">
                    <span></span>
                    <span></span>
                </div>
            </a>
            <transition v-on:enter="enter" v-on:leave="leave">
                <div class="temoignages-item-content" v-if="active === index">

                    <div class="close" @click="active = null">
                        <span></span>
                    </div>

                    <div class="temoignages-item-container">
                        <component :is="item.component" :item="item"></component>
                    </div>
                </div>
            </transition>
        </a>

    </div>

</template>

<script>

    import slugify from 'slugify';

    import Temoignage1Body from "./Temoignages/Temoignage1Body";
    import Temoignage2Body from "./Temoignages/Temoignage2Body";
    import Temoignage3Body from "./Temoignages/Temoignage3Body";
    import Temoignage4Body from "./Temoignages/Temoignage4Body";
    import Temoignage5Body from "./Temoignages/Temoignage5Body";
    import Temoignage6Body from "./Temoignages/Temoignage6Body";
    import Temoignage7Body from "./Temoignages/Temoignage7Body";
    import Temoignage8Body from "./Temoignages/Temoignage8Body";
    import Temoignage9Body from "./Temoignages/Temoignage9Body";

    export default {
        name: "Temoignages",
        props: ['slug'],
        data() {
            return {
                active: null,
                items: [
                    {
                        type: 'FARMERS',
                        name: 'GÉRARD LEHUGER',
                        body: 'CATTLE BREEDER IN PACÉ',
                        picture: 'temoignage-1.jpg',
                        pictureRounded: 'temoignage-1-rounded.jpg',
                        component: Temoignage1Body,
                        color: 'yellow',
                    },
                    {
                        type: 'COMPANIES',
                        name: 'NICOLAS CARLÉSI',
                        body: 'COMPANY DIRECTOR IN ROQUEFORT-LA-BEDOULE',
                        picture: 'temoignage-2.jpg',
                        pictureRounded: 'temoignage-2-rounded.jpg',
                        component: Temoignage2Body,
                        color: 'green'
                    },
                    {
                        type: 'SAVERS AND <br> RETIREES',
                        name: 'VALÉRIE BATIGNE',
                        body: 'COMPANY DIRECTOR IN PARIS',
                        picture: 'temoignage-3.jpg',
                        pictureRounded: 'temoignage-3-rounded.jpg',
                        component: Temoignage3Body,
                        color: 'blue'
                    },
                    {
                        type: 'HEALTH',
                        name: 'BAPTISTE BAUDET',
                        body: 'COMPANY DIRECTOR IN SAINT-REMY-LES-CHEVREUSE',
                        picture: 'temoignage-4.jpg',
                        pictureRounded: 'temoignage-4-rounded.jpg',
                        component: Temoignage4Body,
                        color: 'magenta'
                    },
                    {
                        type: 'SERVICES',
                        name: 'PIERRE BROCHET',
                        body: 'GABRIEL USER IN CEYZERIEU',
                        picture: 'temoignage-5.jpg',
                        pictureRounded: 'temoignage-5-rounded.jpg',
                        component: Temoignage5Body,
                        color: 'green'
                    },
                    {
                        type: 'EMPLOYEES',
                        name: 'ANDREEA DECUSEARA',
                        body: 'EMPLOYEE GROUPAMA ASIGURĂRI (ROMANIA)',
                        picture: 'temoignage-6.jpg',
                        pictureRounded: 'temoignage-6-rounded.jpg',
                        component: Temoignage6Body,
                        color: 'yellow'
                    },
                    {
                        type: 'FINANCIAL<br> PARTNERS',
                        name: 'AURÉLIE ORNON',
                        body: 'FORESTRY MANAGER IN MARCHEPRIME',
                        picture: 'temoignage-7.jpg',
                        pictureRounded: 'temoignage-7-rounded.jpg',
                        component: Temoignage7Body,
                        color: 'blue'
                    },
                    {
                        type: 'A PASSION <br> FOR CYCLING',
                        name: 'THIBAUT PINOT',
                        body: 'PROFESSIONAL ROAD RACER FOR THE GROUPAMA-FDJ TEAM',
                        picture: 'temoignage-8.jpg',
                        pictureRounded: 'temoignage-8-rounded.jpg',
                        component: Temoignage8Body,
                        color: 'green'
                    },
                    {
                        type: 'FOUNDATIONS AND<br> NON-PROFITS',
                        name: 'BÉRANGÈRE PIOGER',
                        body: 'FOUNDER OF THE HONORINE LEVE-TOI CHARITY IN BAYEUX',
                        picture: 'temoignage-9.jpg',
                        pictureRounded: 'temoignage-9-rounded.jpg',
                        component: Temoignage9Body,
                        color: 'magenta'
                    },
                ]
            }
        },
        mounted() {

            let offset = 0;

            if (window.innerWidth <= 500) {
                offset = 50;
            }

            document.querySelector('body').addEventListener('click', (event) => {
                if (event.target.closest('.temoignages-body-template article section .link')) {
                    event.target.closest('.temoignages-body-template article section .link').setAttribute('target', '_blank');
                    if (event.target.closest('.temoignages-body-template article section .link').getAttribute('href') === '#')
                        event.preventDefault();
                    event.target.closest('.temoignages-body-template article section .link')
                        .setAttribute('href', this.$root.base_url + 'en/groupama_RA19-EN.pdf')
                        .click();
                }
            })


            if (this.slug) {
                let index = this.items.findIndex(el => {
                    return slugify(el.name).toLowerCase() === this.slug
                })

                if (index !== null) {
                    this.active = index;
                    setTimeout(() => {
                        window.scroll({
                            top: this.getOffsetTop(document.querySelector('#temoignages-item-bar__' + index)) - offset,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }, 300)
                }
            }
        },
        methods: {
            getOffsetTop(element) {
                let offsetTop = 0;
                while (element) {
                    offsetTop += element.offsetTop;
                    element = element.offsetParent;
                }
                return offsetTop;
            },
            enter(el, done) {
                done();
            },
            leave(el, done) {
                done();
            },
            setActive(index) {

                let offset = 0;

                if (window.innerWidth <= 500) {
                    offset = 50;
                }

                this.active = this.active === index ? null : index;

                if (this.active !== null) {
                    history.pushState({}, '', process.env.VUE_APP_PATH + 'en/agir/' + slugify(this.items[index].name).toLowerCase())
                    this.$root.tag.page.send({name: 'UK_' + 'Agir_' + slugify(this.items[index].name).toLowerCase()});
                } else {
                    history.pushState({}, '', process.env.VUE_APP_PATH + 'en/agir')
                    this.$root.tag.page.send({name: 'UK_' + 'Agir'});
                }

                setTimeout(() => {

                    window.scroll({
                        top: this.getOffsetTop(document.querySelector('#temoignages-item-bar__' + index)) - offset,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 1000)


            }
        }
    }
</script>

<style lang="scss">

    $blue: #2BA5D3;
    $green: #A1BF38;
    $magenta: #C41E4A;
    $yellow: #ECBF3E;
    $green1: rgb(28, 105, 85);


    .border {
        border: 1px solid $green1;
        padding: 20px;
    }

    .close {
        position: sticky;
        top: 0px;
        margin-left: auto;
        text-align: right;
        transform: translate(-25px, 25px);
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ecbf3e;
        cursor: pointer;
        transition: .25s ease;
        transform-origin: center;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0);
        z-index: 9;

        @media screen and (max-width: 500px) {
            top: 40px;
            width: 30px;
            height: 30px;
            transform: translate(0px, 25px);
        }


        &:hover {
            box-shadow: 0 0 5px rgba(0, 0, 0, .2);
            transform: scale(1.05) translate(-25px, 25px);
        }

        span {
            width: 40%;
            height: 2px;
            background: white;
            display: block;
        }
    }

    iframe {
        max-width: 100%;
        display: block;
        margin-bottom: 30px;
    }

    .link-content {
    }

    .temoignages {
        display: flex;
        flex-direction: column;
        padding-left: 220px;
        margin-top: 50px;

        &-item {


            &-bar {
                background: #006b58;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 30px;
                border-top: 1px solid #00352c;
                cursor: pointer;
                transition: .25s ease;
                text-decoration: none;

                &:focus {
                    background: #00604f;
                    outline: none;

                    .temoignages-item {
                        &-body {
                            color: white;
                        }

                        &-more {
                            background: #ecbf3e;
                            transform: scale(1.15);
                            box-shadow: 0 0 5px rgba(0, 0, 0, .5);

                            span {
                                background: white !important;
                            }
                        }
                    }
                }

                &.active {

                    .temoignages-item {

                        &-picture {
                            border: 1px solid white;
                            padding: 7px;
                        }

                        &-more {
                            background: #ecbf3e;
                            transform: rotate(180deg) !important;
                            box-shadow: 0 0 0px rgba(0, 0, 0, .5) !important;

                            span {

                                background: white !important;

                                &:last-child {
                                    height: 2px;
                                }
                            }
                        }
                    }

                }

            }


            &-type {
                color: white;
                font-size: 24px;
                text-transform: uppercase;
                margin-right: 24px;
                font-weight: 900;
                text-align: right;
                width: 300px;
            }

            &-picture {
                margin-right: 36px;
                width: 60px;
                min-width: 60px;
                height: 60px;
                border-radius: 50%;
                display: block;
                transition: .25s ease;
                border: 1px solid transparent;

                + div {
                    margin-right: 10px;
                }

            }

            &-name {
                margin-bottom: 0;
                margin-top: 0;
                color: #ecbf3e;
                text-transform: uppercase;
                font-size: 16px;
                font-weight: 600;
            }

            &-body {
                margin-top: 0;
                margin-bottom: 0;
                text-transform: uppercase;
                font-size: 16px;
                font-weight: 600;
                color: #00352c;
                transition: .25s ease;
            }

            &-more {
                min-width: 60px;
                width: 60px;
                height: 60px;
                min-height: 60px;
                border: 1px solid #00352c;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                position: relative;
                margin-left: auto;
                transition: .25s ease;

                span {
                    background: #00352c;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    transition: .25s ease;

                    &:first-child {
                        width: 21px;
                        height: 2px;
                    }

                    &:last-child {
                        width: 2px;
                        height: 21px;
                    }
                }

            }

            &-content {
                background: white;
                width: 100%;
                position: relative;
            }

            &-container {
                padding: 60px 0;
                margin: auto;
                max-width: 960px;
            }

            &:hover {
                .temoignages-item {
                    &-bar {
                        background: #00604f;
                    }

                    &-body {
                        color: white;
                    }

                    &-more {
                        transform: scale(1.15);
                        box-shadow: 0 0 5px rgba(0, 0, 0, .5);
                        background: #ecbf3e;

                        span {
                            background: white;
                        }
                    }

                }


            }

        }
    }

    @media screen and (max-width: 1280px) {
        .temoignages {
            &-item {
                &-content {
                    padding: 0 15px;
                }
            }
        }
    }

    @media screen and (max-width: 1025px) {
        .temoignages-item-type {
            font-size: 20px;
            flex: 1 0 auto;
            max-width: 200px;
        }
    }

    @media screen and (max-width: 780px) {
        .temoignages {
            padding-left: 0;

            &-item {
                position: relative;

                &-type {
                    text-align: left;
                    font-size: 22px;
                    margin-top: 0;
                }

                &-body {
                    max-width: 290px;
                }

                &-name, &-body {
                    font-size: 11px;
                }

                &-picture {
                    width: 45px;
                    min-width: 45px;
                    height: 45px;
                    margin-right: 20px;

                    + div {
                        width: calc(100% - 65px);
                    }

                }

                &-picture, &-picture + div {
                    display: inline-block;
                    vertical-align: middle;
                }

                &-more {
                    position: absolute;
                    right: 22px;
                    top: 26px;
                    min-width: 35px;
                    min-height: 35px;

                    span:first-child {
                        width: 14px;
                    }

                    span:last-child {
                        height: 14px;
                    }

                }
            }

        }
    }

    @media screen and (max-width: 500px) {

        .temoignages-item-bar {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .temoignages-item-picture {
            margin-right: 0;
            margin-bottom: 20px;
        }
    }

    .temoignages-body-template {
        position: relative;


        .marker {
            padding: 2px;

            &.yellow {
                background: $yellow;
                color: white;
            }

            &.magenta {
                background: $magenta;
                color: white;
            }

            &.blue {
                background: $blue;
                color: white;
            }

            &.green {
                background: $green;
            }

        }

        a {
            color: inherit;
        }

        .close {

            &-box {
                position: absolute;
                right: 10px;
                top: 10px;
            }

            margin-left: auto;
            position: sticky;
            top: 10px;
            right: 10px;
        }

        article {
            display: flex;
            justify-content: space-between;

            section {
                width: 100%;
                display: flex;
                flex-direction: column;

                > .icono {
                    margin-top: 0;
                }

                p + .icono {
                    margin-top: 30px;
                }

                &:first-child {
                    max-width: 340px;
                }

                &:last-child {
                    max-width: 480px;
                }

                &.text-right {
                    text-align: right;

                    .label {
                        align-self: flex-end;
                    }

                    .icono {
                        align-self: flex-end;
                    }

                }

                figure {
                    margin: 0 0 70px;

                    img.picture {
                        max-width: 100%;
                    }

                    figcaption {
                        text-transform: uppercase;
                        text-align: right;
                        font-weight: 600;
                    }
                }


                h1 {
                    text-transform: uppercase;
                    display: flex;
                    flex-direction: column;
                    font-size: 30px;
                    margin-bottom: 60px;
                    margin-top: 0;

                    span {
                        align-self: flex-start;
                        color: white;
                        background: #00604f;
                        padding: 1px 5px 0;

                        em {
                            font-style: normal;
                            color: #ecbf3e;

                            &.yellow {
                                color: $yellow;
                            }

                            &.magenta {
                                color: $magenta;
                            }

                            &.blue {
                                color: $blue;
                            }

                            &.green {
                                color: $green;
                            }

                        }
                    }
                }

                h2 {
                    font-weight: 900;
                    color: #00604f;
                    font-size: 22px;
                    line-height: 25px;
                    text-align: left;
                }

                h3 {
                    color: #ecbf3e;
                    font-size: 16px;
                    text-transform: uppercase;
                    font-weight: 700;
                    line-height: 18px;

                    &.yellow {
                        color: $yellow;
                    }

                    &.magenta {
                        color: $magenta;
                    }

                    &.blue {
                        color: $blue;
                    }

                    &.green {
                        color: $green;
                    }

                }

                p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 500;
                    color: #0b0b0b;

                    &:first-child {
                        margin-top: 0;
                    }


                    &.yellow {
                        color: $yellow;
                    }

                    &.magenta {
                        color: $magenta;
                    }

                    &.blue {
                        color: $blue;
                    }

                    &.green {
                        color: $green;
                    }

                    &.green {
                        color: #00604f;
                    }

                    &.uppercase {
                        text-transform: uppercase;
                    }

                    &.semiBold {
                        font-weight: 700;
                    }

                }

                .label {
                    font-weight: 800;
                    text-transform: uppercase;

                    &.green {
                        background: #004135;
                        padding: 5px;
                        color: white;
                    }

                    + p {
                        margin-top: 0 !important;
                        text-transform: none !important;
                    }

                }

                .marker {
                    &.green {
                        color: white;
                        background: $green;
                        padding: 3px;
                    }
                }

                .number {
                    font-size: 40px;
                    padding: 15px 15px 5px;
                    line-height: 1;
                    display: flex;
                    align-self: flex-end;
                    margin: 0 0 10px;
                    font-weight: 900;
                    white-space: nowrap;

                    sup {

                    }

                    &.yellow {
                        background: $yellow;
                        color: white;
                    }

                    &.magenta {
                        background: $magenta;
                        color: white;
                    }

                    &.blue {
                        background: $blue;
                        color: white;
                    }

                    &.green {
                        background: $green;
                        color: white;
                    }

                    + p {
                        text-transform: none !important;
                        margin-top: 0 !important;
                        margin-bottom: 30px;
                    }
                }

                .link {
                    display: flex;
                    text-decoration: none;
                    margin-top: 30px;
                    padding: 5px;
                    transition: .25s ease;
                    box-shadow: 0 0 5px rgba(0, 0, 0, 0);

                    &:hover {
                        background: #a1bf38;
                        transform: scale(1.02);
                        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

                        .link {
                            &-icon {
                                fill: #00352c;
                            }

                            &-content {
                                p {
                                    color: #00352c;
                                }
                            }
                        }

                    }

                    &-icon {
                        width: 30px;
                        height: 40px;
                        fill: #a1bf38;
                        margin-right: 20px;
                        transition: .25s ease;
                    }

                    &-content {

                        a {
                            &.yellow {
                                color: $yellow;
                            }

                            &.magenta {
                                color: $magenta;
                            }

                            &.blue {
                                color: $blue;
                            }

                            &.green {
                                color: $green;
                            }
                        }

                        p {
                            font-size: 16px;
                            margin: 0;
                            transition: .25s ease;
                            display: inline-block;

                            span {
                                text-decoration: underline;
                            }

                            &:first-child {
                                font-weight: 500;
                                color: #00604f;
                                margin-bottom: 6px;
                            }

                            &:last-child {
                                font-weight: 800;
                                text-transform: uppercase;
                                color: #a1bf38;
                            }
                        }
                    }

                }

                .w96 {
                    max-width: 96px;
                }

                .w200 {
                    max-width: 200px;
                }

                .w300 {
                    max-width: 300px;
                }
            }


            .quote {
                width: 99px;
                height: 71px;
                display: block;

                &.yellow {
                    fill: $yellow;
                }

                &.magenta {
                    fill: $magenta;
                }

                &.blue {
                    fill: $blue;
                }

                &.green {
                    fill: $green;
                }
            }
        }

        @media screen and (max-width: 1280px) {


            article {
                section {
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }

        }

        @media screen and (max-width: 1025px) {


            article {
                section {
                    padding-left: 25px;
                    padding-right: 25px;
                }
            }

            article section .number {
                font-size: 25px;
            }

        }

        @media screen and (max-width: 768px) {
            article section h1 {
                font-size: 20px;
            }
        }

        @media screen and (max-width: 500px) {

            article section .number {
                font-size: 20px !important;
            }

            article section figure img.picture {
                max-height: 200px;
            }

            article section h1 {
                font-size: 15px;
                margin-bottom: 20px;
            }

            article section h2 {
                font-size: 18px;
            }
            article .quote {
                width: 50px;
                height: 35px;
            }

            article {
                flex-direction: column-reverse;
                padding: 0 15px;

                section {
                    padding-left: 10px;
                    padding-right: 10px;

                    &:first-child {
                        margin-top: 40px;
                    }


                    .link {
                        flex-direction: column;
                        justify-content: center;

                        svg {
                            margin: 0 auto 10px;
                        }
                    }

                    .w300 {
                        max-width: 100%;
                    }

                    p {
                        font-size: 14px;
                    }

                }

                &.xs-reverse {
                    flex-direction: column-reverse;
                }

            }


            figure img {
                margin-bottom: 20px;
            }

            figcaption p {
                margin-bottom: 0;
                margin-top: 0px;
            }

        }

    }

    @media screen and (max-width: 500px) {

        .temoignages-body-template article section > figure {
            display: none;
        }

        .temoignages-item-container {
            padding-top: 0;
        }

        .temoignages-item-more {
            width: 35px !important;
            height: 35px !important;
            min-width: 0 !important;
            min-height: 0 !important;
        }

        .temoignages-item-type {
            font-size: 15px;
            text-align: center;
            margin-right: 0;

            br {
                display: none;
            }
        }

        .temoignages-item-name, .temoignages-item-body {
            text-align: center;
        }
    }

</style>
